import "../styles/Call.css"

function CallModal({ isOpen, setIsOpen }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={() => setIsOpen(false)}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <button className="close-btn" onClick={() => setIsOpen(false)}>×</button>
        <h2>Call Us</h2>
        <p>You can reach us directly:</p>
        <a className="modal-btn" href="tel:+27671045485">📞 Call +27 67 104 5485</a>
      </div>
    </div>
  );
}

export default CallModal;